<template>
    <div id="loan-relation-w-applicant-ifc" class="">
        <vs-list>
            <vs-list-item title="Relación con el solicitante (IFC):" class="px-0">
                {{ getRelationText }}
                <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-success stroke-current cursor-pointer"
                    class="ml-2 mt-2" 
                    @click.stop="showFormPopup = true" />
            </vs-list-item>
        </vs-list>

        <vs-popup :active.sync="showFormPopup" title="Relación con el solicitante (IFC)" :close-on-click-outside="false">
            <template #trigger>
                <div></div>
            </template>
            <div class="p-4">
                <vs-select
                    v-model="relationSelected"
                    label="Relación "
                    placeholder="Selecciona una opción"
                    class="w-full"
                    :options="options"
                    :clearable="false"
                    :searchable="false"
                    >
                    <vs-select-item
                        :key="index"
                        :value="item.id"
                        :text="item.text"
                        v-for="( item, index ) in options"
                        class="w-full"
                        />
                </vs-select>
                <div class="mt-4 flex justify-end">
                    <vs-button
                        color="primary"
                        @click="saveRelation()"
                        >Guardar</vs-button>
                    <vs-button
                        class="ml-2"
                        color="danger"
                        @click="showFormPopup = false"
                        >Cancelar</vs-button>
                </div>
            </div>

        </vs-popup>
    </div>
</template>

<script>
import { method } from 'lodash';

const options = [
    { id: 1, value: "no_relation", text: "No relación" },
    { id: 2, value: "1percent_or_more_ifc_equity", text: "1% o más en la ITF → (a)" },
    { id: 3, value: "board_members", text: "Integrar órganos o poder obligar con firma → (b)" },
    { id: 4, value: "spouses_second_grade", text: "Cónyuge / familiares 2º grado de (a)–(b) → (c)" },
    { id: 5, value: "10percent_equity", text: "10% o más en terceras por parte de la ITF → (d)" },
    { id: 6, value: "10percent_equity_spouses_first_grade", text: "10% o más en terceras por parte de personas (a–d), funcionarios, empleados, auditores, comisarios, o ascendientes/descendientes 1º grado y cónyuges → (e)" },
    { id: 7, value: "three_hierarchical_levels", text: "Cargos (consejero/administrador/top 3 niveles) en terceras por parte de ciertos sujetos clave → (f)" }
]
    export default {
        name: "LoanRelationWApplicantIFC",
        data: () => ({
            options: options,
            showFormPopup: false,
            relationSelected: null
        }),
        computed: {
            getRelationText() {
                const relation = this.options.find(opt => opt.value === this.loan.finance.rg_applicant_relation);
                console.log('relation', relation);

                if(relation === undefined) {
                    const numberRelation = this.options.find(opt => opt.id === this.loan.finance.rg_applicant_relation);
                    return numberRelation ? numberRelation.text : '--';
                }

                return relation ? relation.text : '--';
            }
        },
        props: {
            loan: Object
        },
        methods: {
            async saveRelation() {
                try {
                    const payload = {
                        id: this.loan.id,
                        finance: {
                            id: this.loan.finance.id,
                            rg_applicant_relation: this.relationSelected
                        }
                    }
                    this.showLoading(true, "Guardando...");
                    await axios.put(`/api/v2/projects/${this.loan.id}/deepUpdate`, {
                        ...payload
                    });

                    this.loan.finance.rg_applicant_relation = this.relationSelected;
                    this.showFormPopup = false;
                    this.saveSuccessNotif();
                } catch (error) {
                    console.error(error);
                    this.failedOperationNotif();
                } finally {
                    this.showLoading(false);
                }
            }
        }
    }
</script>